// Mock data for iWurks360Digital Solutions website

export const companyInfo = {
  name: "iWurks360Digital Solutions",
  tagline: "The renowned IT Solutions company providing for each client a customized and individually suited Solutions tailored",
  phone: "+1 479.432.1661",
  email: "chidi@iwurks360.com",
  address: "2139 W MLK Jr Blvd, Fayetteville, AR 72701"
};

export const services = [
  {
    id: 1,
    title: "SEO Optimization",
    description: "Boost your online visibility and rank higher on search engines with our proven SEO strategies tailored to your business needs.",
    icon: "Search"
  },
  {
    id: 2,
    title: "Social Media Marketing",
    description: "Engage your audience and build brand loyalty across all major social platforms with data-driven campaigns.",
    icon: "Share2"
  },
  {
    id: 3,
    title: "PPC Advertising",
    description: "Maximize ROI with targeted pay-per-click campaigns that convert clicks into customers.",
    icon: "MousePointerClick"
  },
  {
    id: 4,
    title: "Content Marketing",
    description: "Create compelling content that resonates with your audience and drives meaningful engagement.",
    icon: "FileText"
  },
  {
    id: 5,
    title: "Brand Strategy & Design",
    description: "Build a memorable brand identity that stands out and connects with your target market.",
    icon: "Palette"
  },
  {
    id: 6,
    title: "Digital Strategy",
    description: "Develop comprehensive digital strategies that align with your business goals and drive growth.",
    icon: "TrendingUp"
  },
  {
    id: 7,
    title: "Web Design & Development",
    description: "Create stunning, responsive websites that deliver exceptional user experiences and conversions.",
    icon: "Globe"
  },
  {
    id: 8,
    title: "Video Production",
    description: "Produce high-quality video content that captivates audiences and amplifies your message.",
    icon: "Video"
  },
  {
    id: 9,
    title: "Analytics & Reporting",
    description: "Gain actionable insights with comprehensive analytics and transparent reporting systems.",
    icon: "BarChart3"
  },
  {
    id: 10,
    title: "AI Business Solutions",
    description: "Leverage cutting-edge AI technology to automate processes and unlock new opportunities.",
    icon: "Brain"
  },
  {
    id: 11,
    title: "Brand Reputation Management",
    description: "Protect and enhance your online reputation with proactive monitoring and strategic responses.",
    icon: "Shield"
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "E-Commerce Growth Campaign",
    category: "Social Media Marketing",
    client: "Fashion Retail Co.",
    description: "Increased online sales by 340% through targeted social media campaigns and influencer partnerships.",
    image: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFuYWx5dGljcyUyMGRhc2hib2FyZHxlbnwwfHx8fDE3NzU3OTg5ODZ8MA&ixlib=rb-4.1.0&q=85",
    results: {
      salesIncrease: "340%",
      roi: "450%",
      engagement: "280%"
    }
  },
  {
    id: 2,
    title: "SaaS Platform SEO Overhaul",
    category: "SEO",
    client: "TechStart Solutions",
    description: "Achieved #1 rankings for 47 competitive keywords, driving 500% increase in organic traffic.",
    image: "https://images.unsplash.com/photo-1759661966728-4a02e3c6ed91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGFuYWx5dGljcyUyMGRhc2hib2FyZHxlbnwwfHx8fDE3NzU3OTg5ODZ8MA&ixlib=rb-4.1.0&q=85",
    results: {
      trafficIncrease: "500%",
      keywords: "47",
      conversionRate: "35%"
    }
  },
  {
    id: 3,
    title: "AI-Powered Customer Service",
    category: "AI Solutions",
    client: "FinServe Bank",
    description: "Implemented AI chatbot reducing customer service costs by 60% while improving satisfaction scores.",
    image: "https://images.pexels.com/photos/10020092/pexels-photo-10020092.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    results: {
      costReduction: "60%",
      satisfaction: "92%",
      responseTime: "85% faster"
    }
  },
  {
    id: 4,
    title: "Brand Reputation Recovery",
    category: "Reputation Management",
    client: "Hospitality Group",
    description: "Transformed negative sentiment into positive brand perception with strategic reputation management.",
    image: "https://images.pexels.com/photos/97080/pexels-photo-97080.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    results: {
      sentimentImprovement: "180%",
      reviewRating: "4.8/5",
      brandMentions: "220% increase"
    }
  },
  {
    id: 5,
    title: "Multi-Channel PPC Campaign",
    category: "PPC",
    client: "Real Estate Agency",
    description: "Generated 1,200+ qualified leads with optimized PPC campaigns across Google and social platforms.",
    image: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFuYWx5dGljcyUyMGRhc2hib2FyZHxlbnwwfHx8fDE3NzU3OTg5ODZ8MA&ixlib=rb-4.1.0&q=85",
    results: {
      leads: "1,200+",
      costPerLead: "40% lower",
      conversionRate: "28%"
    }
  },
  {
    id: 6,
    title: "Complete Brand Transformation",
    category: "Branding",
    client: "Healthcare Startup",
    description: "Developed complete brand identity from concept to execution, establishing market leadership.",
    image: "https://images.unsplash.com/photo-1759661966728-4a02e3c6ed91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGFuYWx5dGljcyUyMGRhc2hib2FyZHxlbnwwfHx8fDE3NzU3OTg5ODZ8MA&ixlib=rb-4.1.0&q=85",
    results: {
      brandAwareness: "350% increase",
      marketShare: "15%",
      customerRetention: "87%"
    }
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Transforming Regional Retailer into National E-Commerce Leader",
    client: "Fashion Forward Inc.",
    industry: "Retail & E-Commerce",
    challenge: "Limited online presence with declining foot traffic and outdated digital infrastructure.",
    solution: "Comprehensive digital transformation including website redesign, SEO optimization, social media campaigns, and AI-powered personalization engine.",
    results: [
      "340% increase in online revenue within 12 months",
      "Customer base expanded from 15,000 to 85,000",
      "Capital expenditure reduced by 45% through automation",
      "Average order value increased by 67%"
    ],
    testimonial: "iWurks360Digital Solutions didn't just improve our digital presence—they revolutionized our entire business model. The ROI has been phenomenal.",
    author: "Sarah Mitchell, CEO",
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc3NTc4NDk1M3ww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "SaaS Startup Achieves Market Leadership Through Strategic Digital Marketing",
    client: "CloudSync Technologies",
    industry: "Software & Technology",
    challenge: "New market entrant facing stiff competition from established players with limited marketing budget.",
    solution: "Data-driven content marketing strategy, technical SEO implementation, strategic PPC campaigns, and thought leadership positioning.",
    results: [
      "500% increase in organic traffic in 18 months",
      "Achieved #1 rankings for 47 competitive keywords",
      "Customer acquisition cost reduced by 55%",
      "Revenue growth of 620% year-over-year"
    ],
    testimonial: "The team's strategic approach and execution excellence helped us dominate our niche. We couldn't have asked for a better partner.",
    author: "David Chen, Founder & CTO",
    image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHx0ZWNobm9sb2d5JTIwYnVzaW5lc3N8ZW58MHx8fHwxNzc1Nzk4OTU4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Financial Institution Modernizes Customer Experience with AI",
    client: "Community First Bank",
    industry: "Financial Services",
    challenge: "High customer service costs, long wait times, and decreasing customer satisfaction scores.",
    solution: "Implementation of AI-powered chatbot, automated customer service workflows, sentiment analysis, and omnichannel support platform.",
    results: [
      "60% reduction in customer service operational costs",
      "Customer satisfaction scores improved from 72% to 92%",
      "Response time reduced by 85%",
      "24/7 support coverage achieved"
    ],
    testimonial: "The AI solution exceeded our expectations. We're now providing better service at a fraction of the cost.",
    author: "Robert Johnson, Chief Operations Officer",
    image: "https://images.pexels.com/photos/10020092/pexels-photo-10020092.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const stats = [
  { id: 'client-success', label: "Client Success Stories", value: "250+" },
  { id: 'roi-increase', label: "Average ROI Increase", value: "340%" },
  { id: 'years-excellence', label: "Years of Excellence", value: "12+" },
  { id: 'industry-awards', label: "Industry Awards", value: "28" }
];
